"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _spinner = _interopRequireDefault(require("bender-url!../../img/spinner.png"));

var PreviewScreenshot =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PreviewScreenshot, _React$Component);

  function PreviewScreenshot() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, PreviewScreenshot);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(PreviewScreenshot)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderImage = function () {
      var _this$props = _this.props,
          previewUrl = _this$props.previewUrl,
          error = _this$props.error;

      if (previewUrl) {
        return _react.default.createElement("img", {
          src: previewUrl,
          className: "screenshot"
        });
      } else if (error) {
        return _react.default.createElement("div", {
          className: "error"
        }, _react.default.createElement("div", {
          className: "icon icon-profile-spy"
        }), _react.default.createElement("div", {
          className: "error-text"
        }, _react.default.createElement(_FormattedHTMLMessage.default, {
          message: "results.preview.error"
        })));
      } else {
        return _react.default.createElement("div", {
          className: "loader"
        }, _react.default.createElement("img", {
          src: _spinner.default
        }));
      }
    };

    return _this;
  }

  (0, _createClass2.default)(PreviewScreenshot, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          backgroundUrl = _this$props2.backgroundUrl,
          isMobile = _this$props2.isMobile;
      var rootClasses = (0, _classnames.default)({
        preview: true,
        mobile: isMobile
      });

      if (isMobile) {
        return _react.default.createElement("div", {
          className: rootClasses
        }, this.renderImage(), _react.default.createElement("img", {
          className: "frame",
          src: backgroundUrl
        }));
      }

      return _react.default.createElement("div", {
        className: rootClasses
      }, _react.default.createElement("div", {
        className: "bar"
      }, _react.default.createElement("div", {
        className: "bar-button"
      }), _react.default.createElement("div", {
        className: "bar-button"
      }), _react.default.createElement("div", {
        className: "bar-button"
      })), this.renderImage());
    }
  }]);
  return PreviewScreenshot;
}(_react.default.Component);

exports.default = PreviewScreenshot;
PreviewScreenshot.propTypes = {
  backgroundUrl: _propTypes.default.string,
  previewUrl: _propTypes.default.string,
  isMobile: _propTypes.default.bool,
  error: _propTypes.default.bool
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/PreviewScreenshot.js
// module id = 155
// module chunks = 0